module.exports = __webpack_public_path__ + "img/電気回路_3_4_4.5ed9bbb6.png";